import { render, staticRenderFns } from "./informationCenter.vue?vue&type=template&id=7d10c6c1&scoped=true&"
import script from "./informationCenter.vue?vue&type=script&lang=js&"
export * from "./informationCenter.vue?vue&type=script&lang=js&"
import style0 from "./informationCenter.vue?vue&type=style&index=0&id=7d10c6c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10c6c1",
  null
  
)

export default component.exports